import {Table} from "antd";
import {getColumnSearchProps} from "../widget/SearchProps";
import {PlantStageType} from "../../api/Constants";
import {Link} from "react-router";
import {EmptyMetrcWidget} from "./EmptyMetrcWidget";
import {toFSDateTime} from "../../util/timeutils";
import {useRef} from 'react';

export const BasicPlantTable = ({plants, showGeneration=true, showDestroyed=false, props}) => {
    const numGenerations = plants.length;

    const searchInput = useRef(null);

    const columns = [
        {
            title: 'Name',
            key: 'name',
            dataIndex: 'name',
            ...getColumnSearchProps(`name`, searchInput),
            sorter: (a, b) => a.name.localeCompare(b.name),
            render: (val, record) => {
                const {stage} = record;
                if (stage === PlantStageType.Mom) {
                    return <Link to={`/cultivationapp/mom/${record.id}`}>{val}</Link>
                } else {
                    return <Link to={`/cultivationapp/plant/${record.id}`}>{val}</Link>
                }
            }
        },
        {
            title: 'Description',
            key: 'description',
            dataIndex: 'description',
            ...getColumnSearchProps(`description`, searchInput)
        },
        {
            title: 'Metrc',
            key: 'metricTag',
            dataIndex: 'metricTag',
            ...getColumnSearchProps(`metricTag`, searchInput),
            sorter: (a, b) => a.metricTag.localeCompare(b.metricTag),
            render: (val, record, index) => {
                if ((val === null) || (val ==="")) {
                    return <EmptyMetrcWidget plantId={record.id} />
                } else {
                    return val;
                }
            }
        },
        {
            title: 'Created',
            key: 'creationTime',
            dataIndex: 'creationTime',
            render:(val) => {
                return toFSDateTime(new Date(val));
            },
            sorter: (a, b) => (new Date(a.creationTime))- (new Date(b.creationTime)),
        }
    ];

    if (showGeneration) {
        columns.unshift({
            title: 'Generation',
            key: 'generation',
            dataIndex: 'generation',
            sorter: (a, b) => a-b,
            render: (val, record) => {
                return numGenerations+val;
            }
        })
    }

    if (showDestroyed) {
        columns.push({
            title: 'Destroyed',
            key: 'destroyed',
            dataIndex: 'destructionTime',
            render: (val, record) => {
                return toFSDateTime(new Date(val));
            }
        })
    }

    const tablePagination = {
        defaultPageSize: 50,
        showSizeChanger: true,
        pageSizeOptions: [50, 100, 150, 200]
    }

    return <Table columns={columns} dataSource={plants} pagination={tablePagination} />
}